// vorgangMehrfachAuswahl.ts — was „Übernehmen" in der Mehrfachauswahl
// bedeutet (PO 01.10.2026): Die Auswahl startet mit den bestehenden
// Zuordnungen; verglichen wird gegen sie. React-frei, damit testbar.

import { istNeuesTodoKey, todoKey, vorgangKey } from "./vorgangPickerListe";

/** Eine bestehende Zuordnung, die angehakt vorbelegt wird. */
export type VorbelegtesZiel = {
    vorgangId: number;
    /** null = Vorgangsebene. */
    todoId: number | null;
    /** Anzeige, z. B. „4711-2 · Kfz-Schaden › Gutachten". */
    titel: string;
    unter?: string | null;
    /** Id der Zuordnung beim Aufrufer (Telefonie: `CallLogZuordnung.id`). */
    zuordnungId?: number | null;
};

/** Ein neu gewähltes Ziel — immer mit Vorgang, auch für To-dos. */
export type MehrfachZiel = { key: string; vorgangId: number; todoId: number | null };

export type MehrfachAenderung = { hinzu: MehrfachZiel[]; weg: VorbelegtesZiel[] };

/** Auswahl-Schlüssel eines Ziels: `t:<todo>` bzw. `v:<vorgang>`. */
export const zielKey = (z: { vorgangId: number; todoId: number | null }): string =>
    z.todoId != null ? todoKey(z.todoId) : vorgangKey(z.vorgangId);

/**
 * Auswahl gegen die Vorbelegung: was kam dazu, was wurde abgehakt, und wie
 * viele neue To-dos (`n:<vorgang>`, noch nicht angelegt) stehen drin.
 */
export function auswahlAenderung(
    auswahl: ReadonlyMap<string, number>,
    vorbelegt: ReadonlyMap<string, VorbelegtesZiel>,
): MehrfachAenderung & { neu: number } {
    const hinzu: MehrfachZiel[] = [];
    let neu = 0;
    for (const [key, vorgangId] of auswahl) {
        if (istNeuesTodoKey(key)) {
            neu += 1;
            continue;
        }
        if (vorbelegt.has(key)) continue;
        const id = Number(key.slice(2));
        if (!Number.isInteger(id) || id <= 0) continue;
        if (key.startsWith("t:")) hinzu.push({ key, vorgangId, todoId: id });
        else if (key.startsWith("v:")) hinzu.push({ key, vorgangId: id, todoId: null });
    }
    const weg = Array.from(vorbelegt.entries())
        .filter(([key]) => !auswahl.has(key))
        .map(([, z]) => z);
    return { hinzu, weg, neu };
}

/** Zahlen für die Knopf-Beschriftung (neue To-dos zählen als „hinzu"). */
export function aenderungZahlen(a: MehrfachAenderung & { neu?: number }): { hinzu: number; weg: number } {
    return { hinzu: a.hinzu.length + (a.neu ?? 0), weg: a.weg.length };
}
